import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';

const initialState: UserFeatures = {features:""};

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'userfeatures' })
export class UserFeaturesStore extends Store<UserFeatures> {
	constructor() {
		super(initialState);
	}
}


export interface UserFeatures{
	features: string;
}
